import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fieldTextRenderImage'
})
export class FieldTextRenderImagePipe implements PipeTransform {

  transform(value: string, imageConfig: string | ((value: string) => string)): string {
    if (typeof imageConfig === 'function') return imageConfig(value) || 'assets/images/placeholder.png';

    return imageConfig || 'assets/images/placeholder.png';
  }

}
